import React from 'react';

const PrivacyPage = () => {
    return (
        <div className="container">
            <h1 className="header">Privacy Policy</h1>
            <p><strong>Last updated:</strong> March 20, 2026</p>

            <h2>Age Requirement</h2>
            <p>
                Uranium Baseball is not intended for children under the age of 13. By using this service,
                you confirm that you are at least 13 years old. We do not knowingly collect personal
                information from children under 13.
            </p>

            <h2>What We Collect</h2>
            <p>
                When you create an account, we collect your email address and a username you choose.
                If you sign in with Google or Apple, we receive your name and email from those services.
                We do not access your contacts, photos, or any other data from your Google or Apple account.
            </p>

            <h2>How We Use It</h2>
            <p>
                Your email is used for account authentication and password resets. Your username is displayed
                publicly in leaderboards, game results, and binder pages. We do not sell, rent, or share
                your personal information with third parties for marketing purposes.
            </p>

            <h2>Third-Party Services</h2>
            <p>We use the following third-party services to operate Uranium Baseball:</p>
            <ul>
                <li><strong>AWS (Amazon Web Services)</strong> &mdash; hosts our servers, database, and handles authentication via AWS Cognito.</li>
                <li><strong>Google Sign-In</strong> &mdash; if you choose to sign in with Google, your authentication is processed through Google and AWS Cognito. We receive only your name and email.</li>
                <li><strong>Apple Sign-In</strong> &mdash; if you choose to sign in with Apple, your authentication is processed through Apple. We receive only your name and email (or a relay address if you choose to hide your email).</li>
                <li><strong>Google Analytics</strong> &mdash; collects anonymous usage data to help us understand how the site is used. No personally identifiable information is shared with Google Analytics.</li>
            </ul>

            <h2>Cookies</h2>
            <p>
                We use cookies to keep you logged in and to store your authentication session.
                Google Analytics may set additional cookies to track anonymous usage patterns.
                You can disable cookies in your browser settings, but this may prevent you from logging in.
            </p>

            <h2>Data Storage &amp; Retention</h2>
            <p>
                Your data is stored securely using AWS infrastructure in the United States. Game stats,
                card collections, and account information are stored in our database. We retain your data
                for as long as your account is active. Upon account deletion, your personal information
                is permanently removed from our active systems within 30 days. Automated backups may
                retain data for up to 90 days before expiring.
            </p>

            <h2>Your Rights</h2>
            <p>
                You can request deletion of your account and all associated data by contacting us.
                You can also request a copy of the personal data we hold about you.
            </p>

            <h2>Changes to This Policy</h2>
            <p>
                We may update this privacy policy from time to time. If we make significant changes,
                we will notify users through the site. Continued use of the service after changes
                constitutes acceptance of the updated policy.
            </p>

            <h2>Contact</h2>
            <p>
                For privacy-related questions, reach out via the <a href="/contact">contact page</a>.
            </p>
        </div>
    );
};

export default PrivacyPage;
